export default __webpack_public_path__ + "static/air_curtain_b.fa67cd6544839528ce313a4fb1f555e0.svg";